<template>
    <input
        ref="inputRef"
        class="password-field"
        v-bind="$attrs"
    />
</template>

<script setup>
import {onMounted, ref} from 'vue';

const inputRef = ref(null);

onMounted(() => {
    inputRef.value.focus();
});
</script>

<style scoped>
.password-field {
    padding-right: 80px;
}
</style>
